let lastPath;
let countrySpecificPath;
let countryIsoCode;

export const setLastPath = path => {
  lastPath = path;
};

export const setCountrySpecificPath = value => {
  countrySpecificPath = value;
};

export const setCountryIsoCode = isoCode => {
  countryIsoCode = isoCode;
};

export const getLastPath = () => lastPath;

export const getCountrySpecificPath = () => countrySpecificPath;

export const getCountryIsoCode = () => countryIsoCode;
